import { LatLon } from '../../util/geodesy/latlon';

/**
 * Shared base for location-based business "finder" results — Flying Clubs today, Flight Schools and
 * Universities later. Holds the common proximity/contact fields the AirportsAPI business-finder
 * endpoints return. Subclasses add their type-specific fields and implement a static `parse(data)`.
 */
export abstract class BusinessFinderResult {

  businessId: number;

  name: string;

  city: string;

  stateProvince: string;

  latitude: number;

  longitude: number;

  location: LatLon;

  phone1: string;

  webAddress: string;

  emailAddress: string;

  description: string;

  /**
   * Great-circle distance from the center of the search area, in nautical miles. Null unless a
   * point/radius search was performed.
   */
  distance: number;

  airportIdent: string;

  airportName: string;

  /**
   * All type-specific tag names on the business (e.g. "Flying Club::Benefits::Clubhouse"), used for
   * client-side category facet filtering.
   */
  tags: string[];
}
